<template lang="pug">
  div
    h2
      | Übersicht
    div.my-2
      table(v-if="order")
        tbody
          tr
            td.pl-4(rowspan="10")
              button.btn.btn-secondary.btn-icon.btn-sm.mr-2(
                @click="showOrderHistory"
                )
                svg(viewBox="0 0 24 24")
                  path(fill="white" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z")
            td.header-col.px-4 Datum
            td {{ order.createdAt | dateFormatter }}
            td.header-col.px-5 Kunde
            td.header-col Rechnung
          tr
            td.header-col.px-4 Status
            td
              template(v-if="order.status === orderStatus.ORDER_STATUS_CREATED || order.status === orderStatus.ORDER_STATUS_PROCESSED")
                | Bestellt
              template(v-if="order.status === orderStatus.ORDER_STATUS_SHIPPED")
                | Gesendet
            td.px-5.align-top(rowspan="8")
              | {{ order.customer.name1 }} {{ order.customer.name2 }}
              br
              | {{ order.customer.street }}
              br
              | {{ order.customer.country }}-{{ order.customer.zip }} {{ order.customer.city }}
            td.align-top(rowspan="8")
              button.btn.btn-primary.btn-lg(
                @click="downloadInvoice(order)"
                :disabled="!order.hasInvoice"
                )
                svg(style="width:24px;height:24px" viewBox="0 0 24 24")
                  path(fill="currentColor" d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z")
          tr
            td.header-col.px-4 Preis
            td(v-if="customer && customer.studentProducts === 1") {{ order.orderSummary.totalPriceB2c }}
            td(v-else) {{ order.orderSummary.totalPriceB2b }}
          tr
            td.header-col.px-4 Menge
            td {{ order.orderSummary.totalQuantity }}
          tr
            td.header-col.px-4 {{ discountLabel }}
            td {{ order.orderSummary.onlineDiscount }}
          tr
            td.header-col.px-4 Versandkostenpauschale
            td {{ order.orderSummary.shippingCosts }}
          tr
            td.header-col.px-4 {{ order.orderSummary.vatPercentage }}
            td {{ order.orderSummary.vat }}
          tr
            td.header-col.px-4 Gesamt
            td {{ order.orderSummary.totalPrice }}
          tr
            td.header-col.px-4 Kommentar
            td(colspan="3") {{ order.note }}
    order-summary(
      :order-summary="orderSummary "
      )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import orderSummary from '@/components/orderForm/orderSummary'
import filters from '@/mixins/filters'

export default {
  name: 'ViewOrder',
  components: {
    orderSummary
  },
  mixins: [filters],
  computed: {
    ...mapState({
      orderStatus: state => state.orderFormService.enums.OrderStatus
    }),
    ...mapState('ui', [
      'order'
    ]),
    ...mapGetters('authentication', [
      'customer'
    ]),
    orderSummary () {
      return this.order ? this.order.orderSummary : null
    },
    discountLabel () {
      return this.customer && this.customer.studentProducts === 1
        ? 'Schüler-Rabatt 10%'
        : 'Online-Rabatt 3%'
    }
  },
  mounted () {
    if (!this.order) {
      this.$router.replace({ name: 'order-history' })
    }
  },
  methods: {
    ...mapActions('ui', [
      'downloadInvoice',
      'showOrderHistory'
    ])
  }
}
</script>

<style lang="stylus" scoped>
  td.header-col
    font-weight bold
</style>
